// removed by extract-text-webpack-plugin
module.exports = {"modalWrap":"qempo_PunchCardModal_modalWrap-2GpEm-U","modalImage":"qempo_PunchCardModal_modalImage-3CnpNP4","modalTitle":"qempo_PunchCardModal_modalTitle-1FGLngW","couponWrap":"qempo_PunchCardModal_couponWrap-2_Qcplq","modalLoading":"qempo_PunchCardModal_modalLoading-25SZQJo"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/punch-card/components/PunchCardModal/PunchCardModal.scss
// module id = 1375
// module chunks = 0